import React, { useState } from 'react';
import { MarketplaceHeader } from '../components/layout/MarketplaceHeader';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from '../components/marketplace/HeroSection';
import { CategoryChips } from '../components/marketplace/CategoryChips';
import { RestaurantCard } from '../components/marketplace/RestaurantCard';
import { useMarketplaceData } from '../lib/hooks';
import { Skeleton } from '../components/ui/Skeleton';
import { EmptyState } from '../components/ui/EmptyState';
import { Store } from 'lucide-react';
export function HomePage() {
  const {
    categories,
    featuredRestaurants,
    allRestaurants,
    zones,
    loading
  } = useMarketplaceData();
  const [activeCategory, setActiveCategory] = useState<string>('');
  return <div className="min-h-screen flex flex-col bg-brand-offwhite" data-id="element-1155">
      <MarketplaceHeader data-id="element-1156" />

      <main className="flex-1" data-id="element-1157">
        <HeroSection data-id="element-1158" />

        <div className="max-w-7xl mx-auto py-8" data-id="element-1159">
          {/* Categories */}
          {loading ? <div className="px-4 sm:px-6 lg:px-8 mb-12 flex gap-4 overflow-x-auto" data-id="element-1160">
              {[1, 2, 3, 4, 5, 6].map(i => <Skeleton key={i} className="h-12 w-32 rounded-full shrink-0" data-id="element-1161" />)}
            </div> : <div className="mb-12" data-id="element-1162">
              <CategoryChips categories={categories} activeCategory={activeCategory} onSelect={setActiveCategory} data-id="element-1163" />
            </div>}

          {/* Featured Section */}
          <section className="px-4 sm:px-6 lg:px-8 mb-16" data-id="element-1164">
            <div className="flex items-center justify-between mb-8" data-id="element-1165">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-1166">
                Restaurantes Destacados
              </h2>
            </div>

            {loading ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1167">
                {[1, 2, 3].map(i => <Skeleton key={i} variant="card" className="h-[320px]" data-id="element-1168" />)}
              </div> : featuredRestaurants.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1169">
                {featuredRestaurants.map(restaurant => <RestaurantCard key={restaurant.id} restaurant={restaurant} zoneName={zones.find(z => z.id === restaurant.zone_id)?.name} data-id="element-1170" />)}
              </div> : <EmptyState icon={Store} title="No hay restaurantes destacados" description="Vuelve pronto para descubrir nuevas opciones en tu zona." data-id="element-1171" />}
          </section>

          {/* All Restaurants Section */}
          <section className="px-4 sm:px-6 lg:px-8 mb-16" data-id="element-1172">
            <div className="flex items-center justify-between mb-8" data-id="element-1173">
              <div data-id="element-1174">
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-1175">
                  Todos los Restaurantes
                </h2>
                <p className="text-sm text-gray-500 mt-1" data-id="element-1176">
                  Cada restaurante gestiona sus pedidos directamente
                </p>
              </div>
            </div>

            {loading ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1177">
                {[1, 2, 3, 4, 5, 6].map(i => <Skeleton key={i} variant="card" className="h-[320px]" data-id="element-1178" />)}
              </div> : allRestaurants.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1179">
                {allRestaurants.map(restaurant => <RestaurantCard key={restaurant.id} restaurant={restaurant} zoneName={zones.find(z => z.id === restaurant.zone_id)?.name} data-id="element-1180" />)}
              </div> : <EmptyState icon={Store} title="No se encontraron restaurantes" description="Aún no hay restaurantes disponibles. Vuelve pronto." data-id="element-1181" />}
          </section>
        </div>
      </main>

      <Footer data-id="element-1182" />
    </div>;
}